<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
      <!-- Logo -->
      <router-link to="/" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini">
          <b>D</b>Ad
        </span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg">
          <b>Dinsafer</b>Admin
        </span>
      </router-link>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <div class="sidebar-toggle toggle-menu-icon" @click="toggleMenu">
          <span class="sr-only">Toggle navigation</span>
        </div>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <img
                  v-if="user.icon == ''"
                  src="../../static/img/img_device_user_default.png"
                  class="user-image"
                  alt="User Image"
                >
                <img
                  v-else
                  v-bind:src="'https://d.din.bz/'+user.icon"
                  class="user-image"
                  alt="User Image"
                >
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs">{{ user.uid }}</span>
              </a>

              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img
                    v-if="user.icon == ''"
                    src="../../static/img/img_device_user_default.png"
                    class="img-circle"
                    alt="User Image"
                  >
                  <img
                    v-else
                    v-bind:src="'https://d.din.bz/'+user.icon"
                    class="img-circle"
                    alt="User Image"
                  >
                  <p>{{ user.uid }}</p>
                </li>
                <!-- Menu Body -->
                <!-- <li class="user-body">
                  <div class="row">
                    <div class="col-xs-4 text-center">
                      <a href="#">Followers</a>
                    </div>
                    <div class="col-xs-4 text-center">
                      <a href="#">Sales</a>
                    </div>
                    <div class="col-xs-4 text-center">
                      <a href="#">Friends</a>
                    </div>
                  </div>
                </li>-->
                <!-- Menu Footer-->
                <li class="user-footer">
                  <div class="pull-left">
                    <a
                      class="btn btn-default btn-flat"
                      data-toggle="modal"
                      data-target="#self-agent-profile"
                    >Profile</a>
                  </div>
                  <div class="pull-right" @click="toLogout">
                    <a href="#" class="btn btn-default btn-flat">Logout</a>
                  </div>
                </li>
              </ul>
            </li>

            <!-- Messages-->
            <!--<li class="dropdown messages-menu messages-margin">-->
            <!--<a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">-->
            <!--<i class="fa fa-envelope-o"></i>-->
            <!--<span class="label label-success">{{ userInfo.messages | count }}</span>-->
            <!--</a>-->
            <!--<ul class="dropdown-menu">-->
            <!--<li class="header">You have {{ userInfo.messages | count }} message(s)</li>-->
            <!--<li v-if="userInfo.messages.length > 0">-->
            <!--&lt;!&ndash; inner menu: contains the messages &ndash;&gt;-->
            <!--<ul class="menu">-->
            <!--<li>-->
            <!--&lt;!&ndash; start message &ndash;&gt;-->
            <!--<a href="javascript:;">-->
            <!--&lt;!&ndash; Message title and timestamp &ndash;&gt;-->
            <!--<div class="pull-left">-->
            <!--<img v-bind:src="demo.avatar" class="img-circle" alt="User Image">-->
            <!--</div>-->
            <!--<h4>-->
            <!--Support Team-->
            <!--<small>-->
            <!--<i class="fa fa-clock-o"></i> 5 mins</small>-->
            <!--</h4>-->
            <!--&lt;!&ndash; The message &ndash;&gt;-->
            <!--<p>Why not buy a new awesome theme?</p>-->
            <!--</a>-->
            <!--</li>-->
            <!--&lt;!&ndash; end message &ndash;&gt;-->
            <!--</ul>-->
            <!--&lt;!&ndash; /.menu &ndash;&gt;-->
            <!--</li>-->
            <!--<li class="footer" v-if="userInfo.messages.length > 0">-->
            <!--<a href="javascript:;">See All Messages</a>-->
            <!--</li>-->
            <!--</ul>-->
            <!--</li>-->
            <!-- /.messages-menu -->
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar
      :display-name="user.uid"
      v-if="user.icon == ''"
      picture-url="../../static/img/img_device_user_default.png"
    />
    <sidebar :display-name="user.uid" v-else :picture-url="'https://d.din.bz/'+user.icon"/>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 v-if="typeof($route.query.devicename) !== 'undefined'">
          {{$route.query.devicename}}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <h1 v-else>
          {{$route.query.appname}}
          <small>{{ $route.meta.description }}</small>
        </h1>

        <ol class="breadcrumb">
          <li>
            <router-link :to="{path:'/'}">
              <i class="fa fa-home"></i>Home
            </router-link>
          </li>
          <li class="active">{{$route.query.appname}}</li>
          <li class="active">{{$route.query.devicename}}</li>
        </ol>
      </section>

      <!--self profile dialog-->
      <div class="modal fade in" id="self-agent-profile">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">My Profile</h4>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">
                <div class="form-group modal-user-profile-head">
                  <div title="Edit" class="modal-self-profile-upload-head">
                    <input type="file" @change="uploadfile($event)">
                  </div>
                  <img
                    class="modal-user-profile-img"
                    v-if="currentIcon == ''"
                    src="../../static/img/img_device_user_default.png"
                  >
                  <img
                    class="modal-user-profile-img"
                    v-else
                    v-bind:src="'https://d.din.bz/'+currentIcon"
                  >

                  <div class="upload-profile-img">
                    <div class="progress progress-xxs active" v-show="progress > 0">
                      <div
                        class="progress-bar progress-bar-success progress-bar-striped"
                        role="progressbar"
                        :aria-valuenow="progress"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        :style="'width: ' + progress + '%'"
                      >
                        <span class="sr-only">{{progress}}% Complete</span>
                      </div>
                    </div>
                  </div>

                  <h5>{{ user.uid }}</h5>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label agent-edit-modal-name">E-mail Address</label>
                  <div class="col-sm-9 agent-edit-modal-name">
                    <input
                      id="useremail"
                      class="form-control"
                      v-model="user.email"
                      placeholder="E-mail Address..."
                    >
                  </div>
                </div>

                <!--password-->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="box box-solid collapsed-box modal-new-version-shell-box">
                      <div class="box-header with-border">
                        <h3 class="box-title" style="font-size: 14px;">Change Password</h3>
                        <div class="box-tools">
                          <button type="button" class="btn btn-box-tool" data-widget="collapse">
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                      </div>

                      <div class="box-body">
                        <div class="form-group">
                          <label
                            class="col-sm-3 control-label agent-edit-modal-name"
                          >Original Password</label>
                          <div class="col-sm-9 agent-edit-modal-name">
                            <input id="useropw" class="form-control" placeholder="password">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-3 control-label agent-edit-modal-name">New Password</label>
                          <div class="col-sm-9 agent-edit-modal-name">
                            <input id="usernpw" class="form-control" placeholder="password">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--password-->
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default pull-left"
                data-dismiss="modal"
                aria-label="Close"
              >Cancel</button>
              <button type="button" class="btn btn-info" @click="toDoUpdataUser">Save changes</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- / self profile dialog-->
      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->
    <!-- Main Footer -->
    <!--<footer class="main-footer">-->
    <!--<strong>Copyright &copy; {{year}}-->
    <!--<a href="javascript:;">CoPilot</a>.</strong> All rights reserved.-->
    <!--</footer>-->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import utils from '../utils'
import api from '../api'
import global from './Global.vue'
import main from '../main'

export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      isShowDeviceName: false,
      currentIcon: '',
      user: {},
      progress: 0,
      isuploading: false
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  mounted () {
    var that = this
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem('user') || 'null'
      this.user = JSON.parse(localUserString)
      this.currentIcon = this.user.icon
    }

    window.jQuery('#self-agent-profile').on('hidden.bs.modal', function () {
      that.toUpdataUser()
    })
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    toUpdataUser () {
      if (this.isuploading) {
        api.cancelUpload()
        this.isuploading = false
      }
      this.currentIcon = this.user.icon
      window.jQuery('#useropw').val('')
      window.jQuery('#usernpw').val('')
    },
    toLogout () {
      main.logout()
    },
    uploadfile (event) {
      var that = this
      if (!utils.isEmpty(event.target.files) && !utils.isEmpty(event.target.files[0]) && window.localStorage) {
        this.isuploading = true
        that.toChangeInputStatus()
        api.uploadFile(event.target.files[0], this.$router.app.$store.state.user.token, function (progress) {
          that.progress = progress
        }, function (key, isOk, isCancel) {
          that.isuploading = false
          that.toChangeInputStatus()
          if (isOk) {
            that.currentIcon = key
          } else if (!isCancel) {
            utils.showMsg('upload fail')
          }
        })
      }
    },
    toChangeInputStatus () {
      if (this.isuploading) {
        // 将input元素设置为disabled
        window.jQuery('input[type=\'file\']').attr('disabled', 'disabled')
      } else {
        // 去除input元素的disabled属性
        window.jQuery('input[type=\'file\']').removeAttr('disabled')
      }
    },
    toDoUpdataUser () {
      if (this.isuploading) {
        utils.showMsg('uploading')
        return
      }
      var that = this
      var params = new URLSearchParams()
      var jsons = {
        icon: this.currentIcon,
        opw: window.jQuery('#useropw').val().trim(),
        npw: window.jQuery('#usernpw').val().trim(),
        email: window.jQuery('#useremail').val().trim()
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.request('post', '/updataappuser?_type=json', params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
            utils.showMsg('fail')
          } else {
            that.user.icon = that.currentIcon
            this.$store.commit('SET_USER', that.user)
            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(that.user))
            }
            window.jQuery('#self-agent-profile').modal('hide')
          }
        })
    },
    toggleMenu () {
      var screenSizes = window.jQuery.AdminLTE.options.screenSizes
      if (window.jQuery('body').width() > (screenSizes.sm - 1)) {
        if (window.jQuery('body').hasClass('sidebar-collapse')) {
          window.jQuery('body').removeClass('sidebar-collapse').trigger('expanded.pushMenu')
          this.$bus.emit('ShowBuildVersion', { isShow: true })
        } else {
          window.jQuery('body').addClass('sidebar-collapse').trigger('collapsed.pushMenu')
          this.$bus.emit('ShowBuildVersion', { isShow: false })
        }
      } else {
        if (window.jQuery('body').hasClass('sidebar-open')) {
          window.jQuery('body').removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu')
          this.$bus.emit('ShowBuildVersion', { isShow: false })
        } else {
          window.jQuery('body').addClass('sidebar-open').trigger('expanded.pushMenu')
          this.$bus.emit('ShowBuildVersion', { isShow: true })
        }
      }
      this.$bus.emit('ShowTreeViewFont', { key: '' })
    }
  }
}
</script>

<style lang="less">
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: center;

  img {
    padding: 0.4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.messages-margin {
  margin-right: 13px;
}

.user-menu {
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?29fc9222